export type DocumentStatus = 'DELETED' | 'ERROR' | 'INDEXED' | 'PROCESSING' | 'UPLOAD_FAILED' | 'UPLOADING';

export type UploadedDocument = {
    readonly id: string;
    readonly createdAt: string;
    readonly name: string;
    readonly status: string;
    readonly updatedAt: string;
};

export type FileToUpload = {
    readonly file: File;
    readonly presignedUrl: string;
};

export const isDocumentStatus = (status: string): status is DocumentStatus => {
    return ['UPLOADING', 'UPLOAD_FAILED', 'PROCESSING', 'INDEXED', 'ERROR', 'DELETED'].includes(status);
};
